// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import CurrencyExposant from '../CurrencyExposant';

const P = styled.p`
  text-align: right;
  line-height: 1;

  ${({ $isDesktopStyle, theme }) =>
    $isDesktopStyle
      ? css`
          color: #fff;

          border-top: solid 1px ${theme.grids.colors.middlegrey1};
          border-bottom: solid 1px ${theme.grids.colors.middlegrey1};
          margin: 0;
        `
      : css`
          color: ${theme.grids.colors.black};
        `}
`;

const Span = styled.span`
  position: relative;
  display: inline-block;
  ${({ $isDesktopStyle }) =>
    $isDesktopStyle
      ? css`
          width: 100%;
          margin: 0.4em 0;
        `
      : undefined};
`;

const Text = styled.span`
  position: relative;
  z-index: 1;

  ${({ $isDesktopStyle }) =>
    $isDesktopStyle
      ? css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `
      : css`
          display: inline-block;
        `}
`;

const Outline = styled.span`
  display: inline-block;
  position: absolute;
  bottom: 0.2em;
  left: 0;
  width: 100%;
  height: 0.6em;
  background-color: ${({ theme }) => theme.grids.colors.yellow};
`;

const Stake = styled(CurrencyExposant)`
  font-size: 1.8em;
`;

const Label = styled.span`
  ${!Target.__MOBILE__
    ? css`
        text-align: left;
      `
    : undefined}
`;

type Props = {
  className?: string;
  stake: number;
  label?: string;
  isDesktopStyle?: boolean;
};

const StakeLabel = ({ className, stake, label, isDesktopStyle = false }: Props) => {
  return (
    <P className={className} $isDesktopStyle={isDesktopStyle} data-testid="grid-stake-label">
      <Span $isDesktopStyle={isDesktopStyle}>
        {!isDesktopStyle ? <Outline /> : null}
        <Text $isDesktopStyle={isDesktopStyle}>
          <Label>{label ? `${label} ` : null}</Label>
          <Stake amount={stake} />
        </Text>
      </Span>
    </P>
  );
};

export default StakeLabel;
